module.exports = __webpack_public_path__ + "static/media/tel-info.afd8f764.svg";